import estimates from './estimates';
import invoicePayments from './invoice-payments';
import invoices from './invoices';
import proformaInvoices from './proforma-invoices';
import recurringInvoices from './recurring-invoices';
import salePayments from './sale-payments';
import sales from './sales';
import salesCreditMemoPayments from './sales-credit-memo-payments';
import salesCreditMemos from './sales-credit-memos';
import salesOrders from './sales-orders';

let messages = Object.assign({}, estimates, invoicePayments, invoices, proformaInvoices, recurringInvoices, salePayments, sales, salesCreditMemoPayments, salesCreditMemos, salesOrders);

export default messages;
